import { UPDATE_USERS_LIBRARY } from 'modules/users/store/constants';
import transformArrayToMap from 'utils/transformArrayToMap';

export const updateUsersLibraryAction = (users) => (dispatch) => {
  const transformedUsers = transformArrayToMap(users);

  dispatch({ type: UPDATE_USERS_LIBRARY, payload: { transformedUsers } });
};
